import { render } from "./SchemaClassification.vue?vue&type=template&id=f9699f1c&scoped=true"
import script from "./SchemaClassification.vue?vue&type=script&lang=js"
export * from "./SchemaClassification.vue?vue&type=script&lang=js"

import "./SchemaClassification.vue?vue&type=style&index=0&id=f9699f1c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f9699f1c"

export default script